export enum SCREEN_SIZE {
  XXS = 0,
  XS = 375,
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  XXL = 1536,
}

export const isScreenLessThan = (width: number, smallScreenDef = SCREEN_SIZE.LG): boolean => {
  return width < smallScreenDef;
};
